import { useState } from "react";

interface FAQItemProps {
  question: string;
  answer: string;
  defaultOpen?: boolean;
}

export default function FAQItem({ question, answer, defaultOpen = false }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-background-200/70 rounded-xl overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-background-100/70 transition-colors duration-200"
      >
        <span className="font-heading text-base font-bold text-foreground-900">
          {question}
        </span>
        <div
          className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
            isOpen
              ? "bg-primary-500 text-background-50 rotate-45"
              : "bg-background-200/70 text-foreground-500"
          }`}
        >
          <i className="ri-add-line text-lg"></i>
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
          {answer}
        </div>
      </div>
    </div>
  );
}